/**
 * Notification module atom types.
 *
 * Use these enum values when subscribing to notification atoms.
 * These are kept separate from DefaultAtoms to maintain the optional
 * nature of the notification module.
 */
export enum NotificationAtoms {
  NotificationContent = "NotificationContent",
  UserNotificationInfo = "UserNotificationInfo",
  UserNotificationInbox = "UserNotificationInbox",
}
